import { VehicleOperationalState } from '@backoffice-frontend/graphql'

type VehicleWithOperationalState = {
  id: string
  operationalState: VehicleOperationalState | null
}

export const allVehiclesAreNonOperational = (
  vehicles: VehicleWithOperationalState[],
  expectedVehicleIds: string[],
): boolean => {
  if (expectedVehicleIds.length === 0) return false

  return expectedVehicleIds.every(id =>
    vehicles.some(
      vehicle =>
        vehicle.id === id &&
        vehicle.operationalState === VehicleOperationalState.NonOperational,
    ),
  )
}
